import { useReducer } from 'react';
import Reducer from './reducer';
import { Actions } from './action';
import {
	getAllProjectsApi,
	getTenantUsers,
	getProjectListCorresWorkspaceApi,
	getVendorDetailsApi,
	updateDeliverableApi,
	craeteDeliverable,
	getfiltersCountApi,
	getDeliverablesdataApi
} from "../../views/feature/Deliverables/GraphQlApis"
import {requestExecutor} from '../../controllers/ApiFunctions/index'

export const DeliverState = (props) => {
	const intialState = {
		deliverablesData: null,
		associatedTenants: null,
		projectsList: null,
		filtersCount: null,
		isPageLoading: false,
		isStateLoading:false,
		modalShow: false,
		createModal: false,
		workspaceTenants: null,
		createNewDeliverableState: null,
		workspaceProjectList: null,
		UpdateDeliverableState: null,
		UpdateRecord:null
	};

	const [state, dispatch] = useReducer(Reducer, intialState);

	const getAllEventList = async (vendorId) => {
		const json = {
			vendorId: vendorId,
		};
		const { success, result } = await requestExecutor(getVendorDetailsApi,json,vendorId);

		if (success) {
			dispatch({
				type: Actions.GET_ALL_ASSOCIATED_TENANTS_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_ASSOCIATED_TENANTS_FAILED,
				payload: result,
			});
		}
	};

	const getAlldeliverablesData = async (data, vendorID) => {
		const json = {
			filters: {
				page: +data?.page || 1,
				limit: +data?.limit || 10,
				sortBy: 'dueDate',
				sortType: -1,
				tenantId: data?.workspaceFilter || [],
				userId: data?.AssignedtoFilter || '',
				search: data?.search || '',
			},
		};
		if (data.StatusFilter?.length) {
			json.filters.subFilter = data.StatusFilter;
		}
		if (data.projectsFilter) {
			json.filters.projectId = data.projectsFilter;
		}
		const { success, result } = await requestExecutor(getDeliverablesdataApi,json, vendorID);
		if (success) {
			dispatch({
				type: Actions.GET_ALL_DELIVERABLES_DATA_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_DELIVERABLES_DATA_FAILED,
				payload: result,
			});
		}
	};

	const getAllProjectsList = async (vendorID) => {

		const json = {
			filters: {
				page: 1,
				limit: 10000,
			},
		};

		const { success, result } = await requestExecutor(getAllProjectsApi,json,vendorID);
		if (success) {
			dispatch({
				type: Actions.GET_ALL_PROJECTS_DATA_SUCCES,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_PROJECTS_DATA_FAILED,
				payload: result,
			});
		}
	};

	const getAllfiltersCount = async (data, vendorID) => {
		let json = {};

		if (data && data?.workspaceFilter?.length) {
			json.tenantIds = data?.workspaceFilter;
		}
	
		const { success, result } = await requestExecutor(getfiltersCountApi,json, vendorID);
		if (success) {
			dispatch({
				type: Actions.GET_ALL_FILTERS_COUNT_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_FILTERS_COUNT_FAILED,
				payload: result,
			});
		}
	};
	const updatePageLoading = async (data) => {
		dispatch({
			type: Actions.UPDATE_PAGE_LOADING_STATE,
			payload: data,
		});
	};

	const updateModalState = async (type, data) => {
		dispatch({
			type: Actions.UPADTE_CREATE_DELIVERABLE_MODAL_STATE,
			payload: { type, data },
		});
	};
	const updateCreateDeliverableFilter = async (data) => {
		dispatch({
			type: Actions.UPDATE_CREATE_NEW_DELIVERABLE_DATA,
			payload: data,
		});
	};
	const getAllWorkspaceTenants = async (json, vendorID) => {
		const { success, result } = await requestExecutor(getTenantUsers,json, vendorID);
		if (success) {
			dispatch({
				type: Actions.GET_ALL_WORKSPACE_TENANT_DETAILS_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_WORKSPACE_TENANT_DETAILS_FAILED,
				payload: result,
			});
		}
	};

	const createNewDeliverable = async (json, vendorID) => {
		const { success, result } = await requestExecutor(craeteDeliverable,json, vendorID);
		if (success) {
			dispatch({
				type: Actions.CREATE_NEW_DELIVERABLE_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.CREATE_NEW_DELIVERABLE_FAILED,
				payload: result,
			});
		}
	};

	const updateCreateDeliverableState = async (payload) => {
		dispatch({
			type: Actions.UPDATE_CREATE_DELIVERABLE_STATE,
			payload: payload,
		});
	};

	const getAllWorkspaceProjects = async (json, vendorID) => {
		const { success, result } = await requestExecutor(getProjectListCorresWorkspaceApi,json, vendorID);
		if (success) {
			dispatch({
				type: Actions.GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_FAILED,
				payload: result,
			});
		}
	};

	const updateDeliverable = async (json, vendorID) => {
		const { success, result } = await requestExecutor(updateDeliverableApi,json, vendorID);
		if (success) {
			dispatch({
				type: Actions.UPDATE_DELIVERABLE_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.UPDATE_DELIVERABLE_FAILED,
				payload: result,
			});
		}
	};

	const updateRecord=async(data)=>{
		dispatch({
			type:Actions.PASSING_RECORD_DATA,
			payload:data
		})
	}

	const cancelUpdate=async()=>{
		dispatch({
			type:"UPDATE_DELIVERABLE_CANCELED"
		})
	}
	return {
		...state,
		getAllEventList,
		getAlldeliverablesData,
		getAllProjectsList,
		getAllfiltersCount,
		updatePageLoading,
		updateModalState,
		updateCreateDeliverableFilter,
		getAllWorkspaceTenants,
		createNewDeliverable,
		updateCreateDeliverableState,
		getAllWorkspaceProjects,
		updateDeliverable,
		updateRecord,
		cancelUpdate,
	};
};
